import React, { createContext, useContext } from "react";

export const AzotteGridRowContext = createContext(null);

// Hook, if you ever want to consume row manually
export const useAzotteGridRow = () => useContext(AzotteGridRowContext);

const AzotteGridDetails = ({ children, sx }) => {
  const row = useAzotteGridRow();

  // Support children as function or element
  if (typeof children === "function") {
    return <>{children({ row })}</>;
  }

  return (
    <div sx={sx}>
      
      {React.Children.map(children, (child) =>
        React.isValidElement(child) ? React.cloneElement(child, { row }) : child
      )}
    </div>
  );
};

export default AzotteGridDetails;
